import React from 'react'

export default ({ header, value, onChangeText, prop, multiline, type = 'text', viewOnly, ...props }) => {
    const handleChange = (v) => onChangeText(prop, v.target.value);

    return (
        <div style={{ margin: '8px 0' }}>
            <span htmlFor={prop} style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--text-secondary, #5a6b7b)', marginBottom: 3 }}>{header}</span>
            {/* The header above is display:block, so a leading ": " used to land
                on its own line — and on an empty field it showed as a lone colon.
                Render the value on its own, with a dash when there is nothing. */}
            {!!viewOnly && (
                <div style={{ fontSize: 14, color: 'var(--text, #0f1f2e)' }}>
                    {value === 0 || value ? value : <span style={{ color: 'var(--text-muted, #9aa5b4)' }}>—</span>}
                </div>
            )}
            {!multiline && !viewOnly && (
                <input
                    {...props}
                    type={type}
                    onChange={handleChange}
                    onInput={handleChange}
                    onBlur={handleChange}
                    value={value || ''}
                    className="form-control"
                    id={prop}
                    placeholder={header}
                />
            )}
            {multiline && !viewOnly && (
                <textarea
                    {...props}
                    onChange={handleChange}
                    onInput={handleChange}
                    onBlur={handleChange}
                    value={value || ''}
                    className="form-control"
                    id={prop}
                    rows="3"
                    placeholder={header}
                />
            )}
        </div>
    );
}
